/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LlmStreamFailedMessage } from '../../models/llm-stream-failed-message';

export interface GetnotificationsLlmStreamFailedSchema$Params {
}

export function getnotificationsLlmStreamFailedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsLlmStreamFailedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<LlmStreamFailedMessage>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsLlmStreamFailedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LlmStreamFailedMessage>;
    })
  );
}

getnotificationsLlmStreamFailedSchema.PATH = '/api/hubs/notifications/LlmStreamFailed';
